<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-3">
        <h5>連絡先グループ一覧</h5>
      </div>
      <div class="col-5 text-right">
        <button                       type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>
        <button                       type="button" class="btn-sm btn-outline-primary" v-on:click="importCsv">CSVをimportする</button>
        <button v-show="isRegistered" type="button" class="btn-sm btn-outline-info" v-on:click="sort">表示順を変更する</button>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-11 align-center" v-show="isUseFunction">
        <label>電話帳を選択してください</label>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-3">
        <div class="form-group">
        <select class="form-control" v-model="extraContactId" v-on:change="selectContact">
          <option v-for="option in contactOptions" v-bind:value="option.id" v-bind:key="option.id">
            {{ option.contactName }}
          </option>
        </select>     
        </div>   
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">名称</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(group, index) in groups" v-bind:key="group.id">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ group.displayName }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(group.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      groups: [],
      extraContactId: 0,
      contactOptions: [
        {
          id: 0,
          contactName: "共通連絡先",
          isHierarchyGroupEnabled: false
        }
      ],
      message: '',
      space: '　'
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.getContactList()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.extraContactId = 0,
          this.contactOptions = [
            {
              id: 0,
              contactName: "連絡先",
              isHierarchyGroupEnabled: false
            }
          ]
          this.getContactList()
          this.selectContact()
        }
      }
    )
    if(this.$store.getters.contact.extraContactId == 0) {
      this.selectContact()
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isRegistered: function () {
      return this.groups.length > 0
    },
    isUseFunction: function() {
      return this.serviceName === 'Nichibyo'
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/create/'+this.extraContactId))
    },
    sort() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/sort/'+this.extraContactId))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/modify/'+this.extraContactId+'/'+id))
    },
    importCsv() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/import'))
    },
    search() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var extraContactId = this.extraContactId
          var url = this.$store.getters.contact.isHierarchyGroupEnabled
                      ? "/api/hierarchygroup/management/list" 
                      : "/api/group/management/public/list"          
          axios
            .post(url, {
              hospitalId: hospitalId,
              extraContactId: extraContactId
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.groups = response.data.data.groups.map(element => {
                var name = element.groupName
                element.displayName = this.$store.getters.contact.isHierarchyGroupEnabled ? this.space.repeat(element.hierarchyNo - 1) + name : name
                return element
              })
            })
            .catch(err => {
              this.message = err.message
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    getContactList() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .get("/api/extracontact/management/list/" + hospitalId, {
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.contactOptions = this.contactOptions.concat(response.data.data.extraContacts)
              this.extraContactId = this.$store.getters.contact.extraContactId
              this.search()
            })
            .catch(err => {
              this.message = err.message
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    selectContact() {
      var extraContactId = this.extraContactId
      if (extraContactId === 0){
        this.$store.commit('contact',{
          extraContactId: this.extraContactId, isHierarchyGroupEnabled: this.$store.getters.hospital.isHierarchyGroupEnabled
          })
        this.search()
      } else {
        this.$cognito.isAuthenticated().then((session) => {
          if(session){
            var accessToken = this.getAccessToken(this.$cognito,session)
              axios
                .get("/api/extracontact/management/" + extraContactId, {
                    headers: this.headers(accessToken)
                })
                .then(response => {
                  this.$store.commit('contact',{
                    extraContactId: this.extraContactId, isHierarchyGroupEnabled: response.data.data.extraContact.isHierarchyGroupEnabled
                    })
                  this.search()
                })
                .catch(err => {
                  this.message = err.message
                })
          } else {
            this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
          }
        }).catch((err) => {
            this.message = err.message
        })
      }
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
button {
  margin-right: 10px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.align-center{
  display: flex;
  align-items: center;
}
</style>